import { all } from "redux-saga/effects"
import logoutSaga from "./logoutSaga"
import requestSaga from "./requestSaga"
import refreshTokenSaga from "./refreshTokenSaga"

export default function* sessionRootSaga() {
  while (true) {
    yield all([logoutSaga(), requestSaga(), refreshTokenSaga()])
  }
}
